
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/white-label-nft-marketplace",
      function () {
        return require("private-next-pages/white-label-nft-marketplace/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/white-label-nft-marketplace"])
      });
    }
  